import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import { IInstruction } from "../../api/Instruction";
import { GetInstructionsFromLicenseeReturnFetchUrl } from "../../api/Instruction";
import { ILicenceProfile } from "../../api/LicenceProfile";
import { Grid } from "../Grid";
import { getIconForType } from "../icons/LeapIcons";
import { InstructionsGridProps } from "./InstructionsGridProps";

const GetUrlForInstruction = (
  instruction: IInstruction,
  licenceProfile: ILicenceProfile
) => {
  return `/licence-profile/${licenceProfile.profileNo}/compliance/lr-instruction/${instruction.epainitiatedcorrespondenceid}`;
};

const RefNoCellFunctionFactory = (licenceProfile: ILicenceProfile) => {
  const RefNoCellFunction = (rowInfo: any): JSX.Element => (
    <table>
      <tr>
        <td style={{ paddingTop: "6px" }}>
          <span>{getIconForType("EPA Initiated Correspondence")}</span>
        </td>
        <td>
          <Link to={GetUrlForInstruction(rowInfo.row.original, licenceProfile)}>
            {rowInfo.value}
          </Link>
        </td>
      </tr>
    </table>
  );
  return RefNoCellFunction;
};

const InstructionsGrid = ({
  licenseeReturnId,
  licenceProfile,
}: InstructionsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetInstructionsFromLicenseeReturnFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(licenseeReturnId);

  const tableColumnsBig: Column<Record<string, IInstruction>>[] = [
    {
      Header: "Ref.",
      accessor: "reference",
      Filter: false,
      Cell: RefNoCellFunctionFactory(licenceProfile),
    },
    {
      Header: "Date",
      accessor: "datesubmitted",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Correspondence Type",
      accessor: "correspondencetype",
      Filter: false,
    },
    {
      Header: "Notification",
      accessor: "licensingnotification",
      Filter: false,
      Cell: (rowInfo: any) => (
        <div
          className="long-text"
          dangerouslySetInnerHTML={{ __html: rowInfo.value }}
        ></div>
      ),
    },
  ];

  const tableColumnsSmall: Column<Record<string, IInstruction>>[] = [
    {
      Header: "Ref.",
      accessor: "reference",
      Filter: false,
      Cell: RefNoCellFunctionFactory(licenceProfile),
    },
    {
      Header: "Date",
      accessor: "datesubmitted",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Correspondence Type",
      accessor: "correspondencetype",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { InstructionsGrid };
